







































import { Api } from '@/api'
import { snakeCaseToCamelCase } from '@/utils'
import { assertErrCode, status } from '@/utils/status-codes'
import { Vue, Component } from 'vue-property-decorator'
import { mapMutations } from 'vuex'
import BaseAuth from './BaseAuth.vue'

@Component({
  methods: {
    ...mapMutations('message', {
      showMessage: 'SHOW_MESSAGE'
    })
  },
  components: {
    BaseAuth
  }
})
export default class NewPassword extends Vue {
  // eslint-disable-next-line no-undef
  [index: string]: unknown

  token = ''
  uid = ''
  showMessage!: CallableFunction

  created (): void {
    this.token = (this.$route.query.token as string) || ''
    this.uid = (this.$route.query.uid as string) || ''
  }

  password = ''
  passwordErrs: string[] = []
  loading = false
  show = false

  submit (): void {
    if (this.loading) return
    this.loading = true

    Api.account.resetPassword({
      uid: this.uid,
      token: this.token,
      password: this.password
    })
      .then(() => {
        this.showMessage('Password reset completed. You can login with your new password.')
        this.$router.push({ name: 'Login' })
      })
      .catch(err => {
        if (assertErrCode(err, status.HTTP_400_BAD_REQUEST)) {
          const data = err.response.data
          Object.entries(data).forEach(([field, errMsgs]) => {
            const attr = `${snakeCaseToCamelCase(field)}Errs`
            this[attr] = errMsgs
          })
        }
      })
      .finally(() => {
        this.loading = false
      })
  }
}
